module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0111.jpg?v=434487de";